import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./auth/msalConfig";
import { Navbar } from "./components/Navbar";
import { HomePage } from "./pages/HomePage";
import { ParcelSearchPage } from "./pages/ParcelSearchPage";
import { ParcelDetailPage } from "./pages/ParcelDetailPage";
import { ContractSearchPage } from "./pages/ContractSearchPage";
import { ContractDetailPage } from "./pages/ContractDetailPage";
import { DashboardPage } from "./pages/DashboardPage";
import { PublicListingPage } from "./pages/PublicListingPage";
import { PublicListingDetailPage } from "./pages/PublicListingDetailPage";
import { LandInspectionPage } from "./pages/LandInspectionPage";
import { LeaseSearchPage } from "./pages/LeaseSearchPage";
import { ProtectedRoute } from "./components/ProtectedRoute";

const msalInstance = new PublicClientApplication(msalConfig);

function App() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    msalInstance.initialize().then(() => {
      return msalInstance.handleRedirectPromise();
    }).then(() => {
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0]);
      }
      setReady(true);
    }).catch(console.error);
  }, []);

  if (!ready) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", fontFamily: "Segoe UI, sans-serif", color: "#6b7280" }}>
        Cargando...
      </div>
    );
  }

  return (
    <MsalProvider instance={msalInstance}>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/parcelas" element={<ProtectedRoute><ParcelSearchPage /></ProtectedRoute> }/>
            <Route path="/parcelas/:parcelId" element={<ProtectedRoute><ParcelDetailPage /></ProtectedRoute> }/>
            <Route path="/contratos" element={<ProtectedRoute><ContractSearchPage /></ProtectedRoute>} />
            <Route path="/contratos/:contractId" element={<ProtectedRoute><ContractDetailPage /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
            <Route path="/arrendamiento" element={<PublicListingPage />} />
            <Route path="/arrendamiento/:id" element={<PublicListingDetailPage />} />
            <Route path="/inspeccion" element={<ProtectedRoute><LandInspectionPage /></ProtectedRoute>} />
            <Route path="/leases" element={<ProtectedRoute><LeaseSearchPage /></ProtectedRoute>} />
          </Routes>
          <footer className="bg-white border-t border-gray-100 mt-16">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
              <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-brand-800 rounded-lg flex items-center justify-center text-white font-bold text-xs">AT</div>
                  <div>
                    <div className="text-sm font-medium text-gray-900">Administración de Terrenos</div>
                    <div className="text-xs text-gray-500">Gobierno de Puerto Rico</div>
                  </div>
                </div>
                <div className="text-xs text-gray-400">
                  © {new Date().getFullYear()} Administración de Terrenos de Puerto Rico. Todos los derechos reservados.
                </div>
              </div>
            </div>
          </footer>
        </div>
      </Router>
    </MsalProvider>
  );
}

export default App;
